import React from 'react';

const QuantityInput = ({ onQuantityUpdate, currentQuantity, maxQuantity }) => {
    if (maxQuantity === undefined || maxQuantity === null) maxQuantity = 99999;
    maxQuantity = Math.max(1, maxQuantity);
    let minQuantity = Math.min(1, maxQuantity);

    return (
        <div className="input-group quantity-input-group">
            <input
                min={minQuantity}
                max={maxQuantity}
                defaultValue={minQuantity}
                type="number"
                onChange={(e) => onQuantityUpdate(e.target.value)}
                name="quantity"
                id="quantity"
                className='quantity-field form-control'
                required
                disabled={maxQuantity <= 0}
            />
        </div>
    );
};

export default QuantityInput;